<template>
  <div>
    <!-- Dialog start -->
    <v-dialog v-model="show" :width="500">
      <v-card v-if="inquiry">
        <v-card-title>
          {{ inquiry.full_name }}
        </v-card-title>

        <v-card-text>
          <v-alert dismissible v-if="success" type="success">
            Invitation has been sent to the user.
          </v-alert>

          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.full_name }}</v-list-item-title>
              <v-list-item-subtitle>Full name</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.email }}</v-list-item-title>
              <v-list-item-subtitle>Email</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.phone_number }}</v-list-item-title>
              <v-list-item-subtitle>Phone number</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.address }}</v-list-item-title>
              <v-list-item-subtitle>Address</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.school }}</v-list-item-title>
              <v-list-item-subtitle>School</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.group }}</v-list-item-title>
              <v-list-item-subtitle>Group</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.year_level }}</v-list-item-title>
              <v-list-item-subtitle>Year Level</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="inquiry.referee" class="px-0">
            <v-list-item-content>
              <v-list-item-title
                >{{ inquiry.referee.name }}
                <span v-if="inquiry.referee.contact"
                  >/ {{ inquiry.referee.contact }}</span
                ></v-list-item-title
              >
              <v-list-item-subtitle>Referee</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="px-0" v-if="inquiry.message">
            <v-list-item-content>
              <v-list-item-title>{{ inquiry.message }}</v-list-item-title>
              <v-list-item-subtitle>Message</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>

        <v-card-actions class="d-flex justify-end">
          <v-btn @click="reject" text>Reject</v-btn>
          <v-btn :loading="isSubmitting" @click="invite" class="primary">
            <span v-if="!inquiry.invitation_sent">Send invite</span>
            <span v-else>Resend invite</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirm dialog -->
    <v-dialog v-model="showConfirmation" max-width="290">
      <v-card>
        <v-card-title class="headline">Reject Group Request?</v-card-title>

        <v-card-text>
          This action cannot be undone.
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="green darken-1" text @click="showConfirmation = false">
            Cancel
          </v-btn>

          <v-btn color="green darken-1" text @click="reject($event, true)">
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserInquiry from '@/models/UserInquiry'

export default {
  data() {
    return {
      show: true,
      loading: false,
      inquiry: null,
      isSubmitting: false,
      success: false,
      showConfirmation: false
    }
  },
  mounted() {
    this.getInquiry(this.$route.params.id)
  },
  methods: {
    getInquiry(id) {
      this.loading = true
      UserInquiry.$find(id)
        .then(response => {
          this.inquiry = response
        })
        .catch(() => {
          this.$router.replace({ name: 'inquiries' })
        })
        .then(() => {
          this.loading = false
        })
    },

    invite() {
      this.isSubmitting = true
      this.$api
        .post(`/user-inquiries/${this.inquiry.id}/approve`)
        .then(response => {
          this.success = true
          setTimeout(() => {
            this.success = false
          }, 3000)
        })
        .catch(() => {})
        .then(() => {
          this.isSubmitting = false
        })
    },

    reject(e, confirmed = false) {
      if (!confirmed) {
        this.showConfirmation = true
      } else {
        this.inquiry.delete().then(response => {
          this.$router.replace({ name: 'inquiries' })
        })
      }
    }
  },
  watch: {
    show(show) {
      if (!show) {
        this.$router.push({ name: 'inquiries' })
      }
    }
  }
}
</script>
